import { render, staticRenderFns } from "./DunningExclusions.vue?vue&type=template&id=4b6eb049&scoped=true&"
import script from "./DunningExclusions.vue?vue&type=script&lang=ts&"
export * from "./DunningExclusions.vue?vue&type=script&lang=ts&"
import style0 from "./DunningExclusions.vue?vue&type=style&index=0&id=4b6eb049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6eb049",
  null
  
)

export default component.exports